import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import App from "./app/App";
// import "./app/config/i18n";
import { CompanyDataProvider } from "./app/shared/ReuseComponents/CompanyDataProvider";
import ChunkErrorBoundary from "./ChunkErrorBoundary";

ReactDOM.render(
  <React.StrictMode>
    <ChunkErrorBoundary>
      <CompanyDataProvider>
        <App />
      </CompanyDataProvider>
    </ChunkErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
